import React, { useState } from 'react';
import {
  Card,
  Title,
  Text,
  Button,
  Select,
  SelectItem,
  TextInput,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Badge,
  Switch
} from '@tremor/react';

export function ScheduledReportsPage() {
  const [schedules, setSchedules] = useState([
    {
      id: 1,
      reportName: 'Monthly Re-Commerce Summary',
      frequency: 'monthly',
      nextRun: '2024-04-01 00:00',
      recipients: 'team@example.com',
      status: 'active'
    },
    {
      id: 2,
      reportName: 'Weekly AI Performance',
      frequency: 'weekly',
      nextRun: '2024-03-25 09:00',
      recipients: 'ai-team@example.com, managers@example.com',
      status: 'active'
    },
    {
      id: 3,
      reportName: 'Daily Repair Queue',
      frequency: 'daily',
      nextRun: '2024-03-21 08:00',
      recipients: 'repairs@example.com',
      status: 'paused'
    }
  ]);

  const [newSchedule, setNewSchedule] = useState({
    reportName: '',
    frequency: 'daily',
    time: '09:00',
    recipients: '',
    status: 'active'
  });

  const reports = [
    { value: 'monthly-recom', label: 'Monthly Re-Commerce Summary' },
    { value: 'weekly-ai', label: 'Weekly AI Performance' },
    { value: 'daily-repair', label: 'Daily Repair Queue' },
    { value: 'weekly-finance', label: 'Weekly Financial Report' }
  ];

  const frequencies = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'custom', label: 'Custom Schedule' }
  ];

  const handleInputChange = (field, value) => {
    setNewSchedule(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Save schedule:', newSchedule);
  };

  const toggleStatus = (id) => {
    setSchedules(prev =>
      prev.map(schedule =>
        schedule.id === id
          ? { ...schedule, status: schedule.status === 'active' ? 'paused' : 'active' }
          : schedule
      )
    );
  };

  return (
    <div className="space-y-6">
      <div>
        <Title>Scheduled Reports</Title>
        <Text>Manage automated report generation and distribution</Text>
      </div>

      <Card>
        <div className="space-y-6">
          <Title>New Schedule</Title>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-sm font-medium">Report</label>
              <Select
                value={newSchedule.reportName}
                onValueChange={(value) => handleInputChange('reportName', value)}
              >
                {reports.map((report) => (
                  <SelectItem key={report.value} value={report.value}>
                    {report.label}
                  </SelectItem>
                ))}
              </Select>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium">Frequency</label>
              <Select
                value={newSchedule.frequency}
                onValueChange={(value) => handleInputChange('frequency', value)}
              >
                {frequencies.map((freq) => (
                  <SelectItem key={freq.value} value={freq.value}>
                    {freq.label}
                  </SelectItem>
                ))}
              </Select>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium">Time</label>
              <TextInput
                type="time"
                value={newSchedule.time}
                onChange={(e) => handleInputChange('time', e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium">Recipients</label>
              <TextInput
                placeholder="Enter email addresses (comma-separated)"
                value={newSchedule.recipients}
                onChange={(e) => handleInputChange('recipients', e.target.value)}
              />
            </div>
          </div>

          <div className="flex justify-end space-x-4">
            <Button variant="secondary">Test Send</Button>
            <Button onClick={handleSave}>Save Schedule</Button>
          </div>
        </div>
      </Card>

      <Card>
        <Title>Active Schedules</Title>
        <Table className="mt-6">
          <TableHead>
            <TableRow>
              <TableHeaderCell>Report Name</TableHeaderCell>
              <TableHeaderCell>Frequency</TableHeaderCell>
              <TableHeaderCell>Next Run</TableHeaderCell>
              <TableHeaderCell>Recipients</TableHeaderCell>
              <TableHeaderCell>Status</TableHeaderCell>
              <TableHeaderCell>Actions</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schedules.map((schedule) => (
              <TableRow key={schedule.id}>
                <TableCell>{schedule.reportName}</TableCell>
                <TableCell className="capitalize">{schedule.frequency}</TableCell>
                <TableCell>{schedule.nextRun}</TableCell>
                <TableCell>{schedule.recipients}</TableCell>
                <TableCell>
                  <Badge
                    color={schedule.status === 'active' ? 'green' : 'gray'}
                    size="sm"
                  >
                    {schedule.status}
                  </Badge>
                </TableCell>
                <TableCell>
                  <div className="flex items-center space-x-3">
                    <Switch
                      checked={schedule.status === 'active'}
                      onChange={() => toggleStatus(schedule.id)}
                    />
                    <Button size="xs" variant="secondary">Edit</Button>
                    <Button size="xs" variant="secondary" color="red">Delete</Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}